// src/theme/useTheme.ts
import { useThemeContext } from './ThemeContext';
import type { LayoutItem } from '../Config/config';

export function useTheme() {
    const { config, actions, resolveComponents } = useThemeContext();
    const isModuleEnabled = (name: string) => !!config.modules?.[name];
    const getComponentParams = (component: string) => config.componentParams?.[component] ?? {};
    const resolveLayoutItems = (items: LayoutItem[]) => resolveComponents(items);
    return { config, actions, isModuleEnabled, getComponentParams, resolveLayoutItems };
}
